import IPaciente from "../types/Paciente";
import moment from 'moment';
import 'moment/dist/locale/es';
import ILog from "../types/Log";
import LogService from "../services/LogService";
import * as constantes from "../common/Constantes";
import IAsistenciaDoc from "../types/AsistenciaDoc";

moment.locale(constantes.momentLocale);

const sortPacientesAlphabetically = (data: any) => {
    try {
        const result = data.sort((a: any,b: any) => {
            return (a.nombre < b.nombre) ? -1 : 0;
        });
        return result;
    } catch (e: any) {
        const error: ILog = { method: 'PacienteService.sortPacientesAlphabetically', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
    }
    
};

const sortPacientesByInternalID = (pacientes: any): any => {
    try {
        const nID = pacientes.filter((p: any) => !p.internalID);
        let yID = pacientes.filter((p: any) => p.internalID);
        yID = yID.sort((a: any,b: any) => {
            return a.internalID - b.internalID;
        });
        const result = [...yID, ...nID];
        return result;
    } catch (e: any) {
        const error: ILog = { method: 'PacienteService.sortPacientesByInternalID', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
    }
};

const formatPacientesGrid = (pacientes: IPaciente[]) => {
    try {
        const pacientesGrid: any = [];

        pacientes.map(paciente => {
            let pacienteGrid = {
                id: paciente._id,
                internalID: paciente.internalID,
                nombre: `${paciente.nombre} ${paciente.apellidos}`,
                edad: paciente.fechaNacimiento && calcularEdad(paciente.fechaNacimiento),
                email: paciente.email,
                telefono: paciente.telefono,
                updatedAt: moment(paciente.updatedAt).fromNow(),
                actividad: paciente.actividad
            };
            pacientesGrid.push(pacienteGrid);
            return pacienteGrid;    
        });  
        return pacientesGrid;
    } catch (e: any) {
        const error: ILog = { method: 'Utils.Pacientes.formatPacientesGrid', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
    }
    
};

const calcularEdad = (fechaNacimiento: string) => {
    try {
        let diff_ms = Date.now() - new Date(fechaNacimiento).getTime();
        let edad_dt = new Date(diff_ms);
        return Math.abs(edad_dt.getFullYear() - 1970);
    } catch (e: any) {
        const error: ILog = { method: 'Utils.Pacientes.calcularEdad', level: 'error', message: e.message, meta: e.message };
        LogService.logError(error);
    }
    
};

const getSexo = (index: string) => {
    return constantes.sexos[parseInt(index)];
};

const getConocido = (index: string) => {
    return constantes.formaConocer[parseInt(index)];
};

const canSendEmail = (loading: boolean, auth?: boolean, email?: string, successMsg: string = "Enviar factura", validateDoc: boolean = false, asistenciaDoc?: IAsistenciaDoc) => {
    const isDisabledEmail =
      loading ||
      !auth ||
      !email ||
      (validateDoc && !asistenciaDoc);

    const tooltipMsg = loading
      ? "Enviando..."
      : validateDoc && !asistenciaDoc
      ? "Es necesesario configurar el justificante de asistencia"
      : !auth
      ? "El paciente no ha autorizado el envío por email"
      : !email
      ? "El paciente no tiene correo electrónico"
      : successMsg;

    return {
      isDisabledEmail,
      tooltipMsg,
    };
};

const canSendFactura = (loading: boolean, auth?: boolean, email?: string, estado?: string, facturaRectificadaId?: string | null) => {
    const base = canSendEmail(loading, auth, email);
    const esBorrador = estado === "Borrador";
    const estaRectificada = !!facturaRectificadaId;

    const motivoFactura = esBorrador
      ? "No se puede enviar un borrador"
      : estaRectificada
      ? "Esta factura está rectificada: envía la rectificativa vigente"
      : undefined;

    return {
      isDisabledEmail: base.isDisabledEmail || !!motivoFactura,
      tooltipMsg: !base.isDisabledEmail && motivoFactura ? motivoFactura : base.tooltipMsg,
    };
};

const PacientesUtils = {
    sortPacientesAlphabetically,
    sortPacientesByInternalID,
    formatPacientesGrid,
    calcularEdad,
    getSexo,
    getConocido,
    canSendEmail,
    canSendFactura
};

export default PacientesUtils;